import { z } from 'zod';
import { citySchema } from '../common/city.js';
import { emailSchema } from '../common/email.js';
import { firstNameSchema } from '../common/first-name.js';
import { lastNameSchema } from '../common/last-name.js';
import { countryCodeSchema, phoneNumberSchema, validatePhone } from '../common/phone-number.js';
import { stateSchema } from '../common/state.js';
import { streetAddressSchema } from '../common/street-address.js';
import { unitSchema } from '../common/unit.js';
import { zipCodeSchema } from '../common/zip-code.js';
import { inquiryPropertyTypeEnum } from './property-type.js';
export const inquiryPropertySchema = z.object({
    street_address: streetAddressSchema,
    property_type: z.enum(inquiryPropertyTypeEnum).meta({ field: 'select' }),
    unit: unitSchema.optional(),
    city: citySchema,
    state: stateSchema,
    zip_code: zipCodeSchema,
});
export const inquiryPropertyManagementSchema = z
    .object({
    first_name: firstNameSchema,
    last_name: lastNameSchema,
    email: emailSchema,
    phone_number: phoneNumberSchema,
    phone_number_country_code: countryCodeSchema,
    properties: z.array(inquiryPropertySchema).min(1).meta({ field: 'properties' }),
})
    .superRefine((data, ctx) => {
    validatePhone(ctx, 'phone_number', data.phone_number, data.phone_number_country_code);
});
